import React, { forwardRef, useImperativeHandle } from "react";

import { useDispatch } from "react-redux";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

import { StripeWrapper } from "../../../../components";
import { alertActions } from "../../../../store/actions";

const StripeForm = forwardRef((props, ref) => {
    const stripe = useStripe();
    const elements = useElements();
    const dispatch = useDispatch();

    useImperativeHandle(ref, () => ({
        async getPaymentMethod() {
            const card = elements.getElement(CardElement);
            if (!stripe || !elements) {
                return;
            }

            const result = await stripe.createPaymentMethod({
                type: 'card',
                card: card
            });

            if (result.error) {
                card.clear()
                dispatch(alertActions.error(result.error.message))
                throw new Error(result.error.message);
            }
            else return result

        },
        async handleToken(intent_client_secret) {
            const card = elements.getElement(CardElement);
            if (!stripe || !elements) {
                return;
            }
            const result = await stripe.confirmCardPayment(intent_client_secret, {
                payment_method: {
                    card: card,
                    billing_details: {
                    },
                }
            });
            if (result.error) {
                card.clear()
                return result;
            } else {
                return result;
            }
        }
    }));

    return (
        <div className="FormGroup">
            <div className="FormRow">
                <CardElement
                    options={{
                        hidePostalCode: true,
                        style: {
                            base: {
                                fontSize: '16px',
                                color: '#424770',
                                '::placeholder': {
                                    color: '#aab7c4',
                                },
                            },
                            invalid: {
                                color: '#9e2146',
                            },
                        },
                    }}
                />
            </div>
        </div>
    );
});

const StripeCardForm = forwardRef((props, ref) => {
    return props.state.stripePublicKey ? <StripeWrapper public_key={props.state.stripePublicKey}>
        <StripeForm ref={ref} />
    </StripeWrapper> : null
})

export default StripeCardForm;